<template>
<div class="login">

  <v-flex xs12 md6 >
            <v-divider class="mt-12"></v-divider>
                <h4 class="text-center">Registro Cliente</h4>
            <v-divider></v-divider>

          <v-form
              ref="form"
              class="mr-6 ml-6"
              v-model="valid"
              lazy-validation
            >
              <v-text-field
                v-model="dni"
                :counter="8"
                :rules="dniRules"
                label="Dni"
                required
              ></v-text-field>

              <v-text-field
                v-model="name"
                :counter="30"
                :rules="nameRules"
                label="Nombres Completos"
                required
              ></v-text-field>

              <v-text-field
                v-model="cell"
                :counter="10"
                :rules="cellRules"
                label="Celular"
                required
              ></v-text-field>

              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="E-mail"
                required
              ></v-text-field>
                    <v-text-field
            v-model="pass"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min]"
            :type="show1 ? 'text' : 'password'"
            name="input-10-1"
            label="Contraseña"
            hint="At least 8 characters"
            counter
            @click:append="show1 = !show1"
          ></v-text-field>

            </v-form>
            
        <v-card-actions>
            <v-btn
            :disabled="!valid"
            block
            color="success"
            class="mr-4"
            @click.stop="agregar"
            >
              Guardar
            </v-btn>
        </v-card-actions>

    
  </v-flex>




  </div>
</template>

<script>
// @ is an alias to /src
import slide from '@/components/slide';
import { db } from '../db'
import firebase from 'firebase'

export default {
  name: 'registraUsuario',

  data() {
        return {
        cliente:[],

        valid: true,
        dni: '',
        dniRules: [
        v => !!v || 'Dni is required',
        v => (v && v.length == 8) || 'dni must be less than 8 characters',
      ],
        name: '',
        nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 30) || 'Name must be less than 10 characters',
      ],
        cell: '',
        cellRules: [
        v => !!v || 'Cell is required',
        v => (v && v.length <= 10) || 'cellphone must be less than 10 characters',
      ],
        email: '',
        emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      pass:'',
          rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
          emailMatch: () => ('The email and password you entered don\'t match'),
        },
        }
      },
       methods: {

        agregar(){
                this.$refs.form.validate()
            if(this.dni!="" && this.email!=""){
                this.cliente = [],
                this.cliente.push({
                    dni:this.dni,
                    nombre:this.name,
                    celular:this.cell,
                    email:this.email 
                }),

                    firebase.auth().createUserWithEmailAndPassword(this.email,this.pass)
                    .then(user =>{
                      console.info("Exito")
                    }).catch(err=>{
                      console.info("error pass")
                    })

                }


        },
        validate () {
            this.$refs.form.validate()
        },
    },

}
</script>